// 文件CDN地址
export const fileServerBaseUrl = 'https://te--fileservers.oss-cn-hangzhou.aliyuncs.com';

// 系统参数
export const sysParam = {
  token: 'Authorization',
};

// 常用图片url
export const commonUrl = {
  beianUrl: 'https://beian.miit.gov.cn',
  loading: 'https://te--fileservers.oss-cn-hangzhou.aliyuncs.com/web/icons/loading.gif',
  contactSeller: 'https://te--fileservers.oss-cn-hangzhou.aliyuncs.com/web/icons/contact-seller.png',
  contactSellerLarge: 'https://te--fileservers.oss-cn-hangzhou.aliyuncs.com/web/icons/contact-seller-large.png',
  occupancyImg: 'https://te--fileservers.oss-cn-hangzhou.aliyuncs.com/web/occupancy-img.png',
  noPermissionBg: 'https://te--fileservers.oss-cn-hangzhou.aliyuncs.com/web/admin/bg-no-permission.png',
};

// 导出操作使用的页面地址
export const exportPagePath = `${location.origin}/admin-order-manage/order-list-export`;
// 交易系统
export const tradingSystem = [
  {
    name: '全部',
    status: '',
  },
  {
    name: '代理采购',
    status: 1,
  },
  {
    name: '同行采购',
    status: 2,
  },
  {
    name: '修理厂采购',
    status: 3,
  },
  {
    name: '车主采购',
    status: 4,
  },
  {
    name: '厂商联',
    status: 5,
  },
  {
    name: '英文版厂商联',
    status: 6,
  },
];

// 交易系统
export const tradingSystems = [
  {
    name: '全部',
    status: '',
  },
  {
    name: '代理采购',
    status: 1,
  },
  {
    name: '同行采购',
    status: 2,
  },
  {
    name: '修理厂采购',
    status: 3,
  },
  {
    name: '车主采购',
    status: 4,
  },
  {
    name: '厂商联',
    status: 5,
  },
];

// 促销活动状态
export const authStatus = [
  {
    name: '全部',
    status: '',
  },
  {
    name: '待审核',
    status: '1',
  },
  {
    name: '未开始',
    status: '2',
  },
  {
    name: '促销中',
    status: '3',
  },
  {
    name: '已结算',
    status: '4',
  },
  {
    name: '审核拒绝',
    status: '5',
  },
];

// 使用类型
export const useType = [
  {
    name: '索赔单生成',
    value: 1,
  },
  {
    name: '账期结算',
    value: 2,
  },

  {
    name: '退款',
    value: 3,
  },
  {
    name: '线下结算',
    value: 4,
  },
];

// 用户类型
export const mumberTypeArr = [
  {
    label: '全部',
    value: '',
  },
  {
    label: 'admin',
    value: 1,
  },
  {
    label: '品牌商',
    value: 2,
  },
  {
    label: '经销商',
    value: 3,
  },
  {
    label: '修理厂',
    value: 4,
  },
  {
    label: '车主',
    value: 5,
  },
  {
    label: '工厂',
    value: 6,
  },
];

export const userTypeArr = [
  {
    label: '全部',
    value: '',
  },
  {
    label: '品牌商',
    value: 2,
  },

  {
    label: '经销商',
    value: 3,
  },

  {
    label: '修理厂',
    value: 4,
  },
  {
    label: '车主',
    value: 5,
  },
  {
    label: '工厂',
    value: 6,
  },
];

// 配件类型
export const productTypeEnumArr = [
  {
    label: '零部件',
    value: 1,
  },
  {
    label: '油电轮',
    value: 2,
  },
];

// ERP类型
export const erpTypeEnumArr = [
  {
    name: '用心',
    value: 1,
  },
  {
    name: '长远',
    value: 2,
  },
  {
    name: '思锐',
    value: 3,
  },
  {
    name: '汽配云',
    value: 4,
  },
  {
    name: '用友',
    value: 5,
  },
  {
    name: '大友',
    value: 6,
  },
  {
    name: '管易云',
    value: 7,
  },
  {
    name: '拆车件',
    value: 8,
  },
];

// 订单状态
export const orderStatus = [
  {
    name: '全部',
    value: '',
    statsKey: 'all',
  },
  {
    name: '待确认',
    value: 1,
    statsKey: 'delayNotarize',
  },
  {
    name: '待支付',
    value: 2,
    statsKey: 'delayPay',
  },
  {
    name: '待发货',
    value: 3,
    statsKey: 'delayShipments',
  },
  {
    name: '待收货',
    value: 4,
    statsKey: 'delayReceiving',
  },
  {
    name: '已收货',
    value: 5,
    statsKey: 'received',
  },
  {
    name: '交易完成',
    value: 6,
    statsKey: 'successed',
  },
  {
    name: '交易关闭',
    value: 7,
    statsKey: 'canceled',
  },
];

//  订单渠道
export const orderChannel = [
  {
    name: '全部',
    value: '',
  },
  {
    name: 'APP',
    value: 1,
  },
  {
    name: 'WEB',
    value: 2,
  },
  {
    name: 'WAP',
    value: 3,
  },
];

// 订单来源
export const orderSource = [
  {
    name: '全部',
    value: '',
  },
  {
    name: '商城订单',
    value: 1,
  },
  {
    name: '询盘订单',
    value: 2,
  },
  {
    name: '推荐订单',
    value: 3,
  },
  {
    name: '虚拟订单',
    value: 4,
  },
  {
    name: '拼团订单',
    value: 5,
  },
  {
    name: '新人专享',
    value: 6,
  },
];

// 订单支付方式
export const orderPayWay = [
  {
    name: '全部',
    value: '',
  },
  {
    name: '通联网关支付',
    value: 1,
  },
  {
    name: '支付宝',
    value: 2,
  },
  {
    name: '微信',
    value: 3,
  },
  {
    name: '快捷支付',
    value: 4,
  },
  {
    name: '线下支付',
    value: 5,
  },
  {
    name: '索赔抵充',
    value: 6,
  },
  {
    name: '账期支付',
    value: 7,
  },
];

// 支付方式(对账单)
export const paymentMethods = [
  {
    name: '全部',
    value: '',
  },
  {
    name: '账期支付',
    value: 1,
  },
  {
    name: '在线支付',
    value: 2,
  },
  {
    name: '线下支付',
    value: 3,
  },
];

// 平台结算方式(对账单)
export const settlementMethods = [
  {
    name: '全部',
    value: '',
  },
  {
    name: '账期支付',
    value: 1,
  },
  {
    name: '企业网银',
    value: 2,
  },
  {
    name: '个人网银',
    value: 3,
  },
  {
    name: '快捷支付',
    value: 6,
  },
  {
    name: '支付宝APP',
    value: 10,
  },
  {
    name: '支付宝扫码',
    value: 4,
  },
  {
    name: '微信APP',
    value: 7,
  },
  {
    name: '微信扫码',
    value: 5,
  },
  {
    name: '线下支付',
    value: 8,
  },
  {
    name: '索赔抵充',
    value: 9,
  },
];

// 结算状态(对账单)
export const settlementStatus = [
  {
    name: '全部',
    value: '',
  },
  {
    name: '待结算',
    value: 2,
  },
  {
    name: '结算预警',
    value: 5,
  },
  {
    name: '已结算',
    value: 3,
  },
  {
    name: '待审核',
    value: 1,
  },
  {
    name: '已关闭',
    value: 4,
  },
  {
    name: '结算失败',
    value: 6,
  },
];

// 质保期
export const qualityAssurance = [
  {
    lable: '1个月',
    value: 1,
  },
  {
    lable: '2个月',
    value: 2,
  },
  {
    lable: '3个月',
    value: 3,
  },
  {
    lable: '6个月',
    value: 6,
  },
  {
    lable: '1年',
    value: 12,
  },
  {
    lable: '18个月',
    value: 18,
  },
  {
    lable: '2年',
    value: 24,
  },
];

// 售后订单状态
export const orderSaleAfterFlag = [
  {
    label: '全部',
    value: '0',
    statsKey: 'allSum',
  },
  {
    label: '待处理',
    value: '1',
    statsKey: 'pendingSum',
  },
  {
    label: '待确认收货',
    value: '5',
    statsKey: 'receivingSum',
  },
  {
    label: '申诉中',
    value: '9',
    statsKey: 'appealingSum',
  },
  {
    label: '待退货',
    value: '4',
    statsKey: 'returnedingSum',
  },
  {
    label: '待退款',
    value: '10',
    statsKey: 'waitRefundSum',
  },
  {
    label: '退款中',
    value: '7',
    statsKey: 'returnedMoneySum',
  },
  {
    label: '拒绝请求',
    value: '2',
    statsKey: 'rejectedSum',
  },
  {
    label: '拒绝收货',
    value: '6',
    statsKey: 'rejectedThtkSum',
  },
  {
    label: '售后取消',
    value: '8',
    statsKey: 'cancelSum',
  },
  {
    label: '售后完成',
    value: '3',
    statsKey: 'flowOverSum',
  },
];

// 售后类型
export const afterSaleType = [
  {
    label: '仅退款',
    value: 1,
  },
  {
    label: '退货退款',
    value: 2,
  },
];

export const unionType = [
  {
    name: '全部',
    value: '',
  },
  {
    name: '卖家联盟',
    value: '1',
  },
  {
    name: '买家联盟',
    value: '4',
  },
  {
    name: '经销商买家联盟',
    value: '2',
  },
  {
    name: '修理厂买家联盟',
    value: '3',
  },
];

export const unionTransactionType = [
  {
    name: '全部',
    value: '',
  },
  {
    name: '经销商',
    value: '2',
  },
  {
    name: '修理厂',
    value: '3',
  },
];

export const bindingType = [
  {
    name: '全部',
    value: '',
  },
  {
    name: '仅展示联盟商家',
    value: '1',
  },
  {
    name: '优先推荐联盟商家',
    value: '2',
  },
];

export const isFrozen = [
  {
    name: '冻结',
    value: 0,
  },
  {
    name: '开启',
    value: 1,
  },
];

// 线下支付权限状态
export const permissionStatus = [
  {
    name: '全部',
    value: '',
  },
  {
    name: '启用',
    value: 0,
  },
  {
    name: '冻结',
    value: 1,
  },
];

// 申诉状态
export const appealStatus = [
  {
    name: '全部',
    value: '0',
  },
  {
    name: '待处理',
    value: '1',
    statsKey: 'pendingSum',
  },
  {
    name: '已同意',
    value: '2',
  },
  {
    name: '已拒绝',
    value: '3',
  },
];

// 商品销售状态
export const goodsSaleStatus = [
  {
    name: '在售',
    value: 2,
  },
  {
    name: '下架',
    value: 1,
  },
];

// 开票类型
export const billingTypes = [
  {
    name: '全部',
    value: '',
  },
  {
    name: '开票',
    value: 1,
  },
  {
    name: '不开票',
    value: 0,
  },
];

// 发票类型
export const invoiceType = [
  {
    name: '增值税普票',
    value: 1,
  },
  {
    name: '增值税专票',
    value: 2,
  },
];
// 推荐位置
export const recommendPlaces = [
  {
    name: '全部',
    value: '',
  },
  {
    name: '首页',
    value: 1,
  },
];

// 结算周期
export const settlementCycle = [
  {
    name: '全部',
    value: '',
  },
  {
    name: '周结',
    value: 1,
  },
  {
    name: '半月结',
    value: 2,
  },
  {
    name: '月结',
    value: 3,
  },
];

export const pushStatus = [
  {
    name: '待推送',
    value: 1,
  },
  {
    name: '推送成功',
    value: 2,
  },
  {
    name: '推送失败',
    value: 3,
  },
  {
    name: '取消推送',
    value: 4,
  },
];

export const groupType = [
  {
    name: '经销商',
    value: 3,
  },
  {
    name: '修理厂',
    value: 4,
  },
];

export const billStatus = [
  {
    name: '对账中',
    value: 1,
  },
  {
    name: '待付款',
    value: 2,
  },
  {
    name: '付款成功',
    value: 3,
  },
  {
    name: '付款失败',
    value: 6,
  },
  {
    name: '付款中',
    value: 7,
  },
];

// 缺货原因
export const shortageReason = [
  {
    name: '全部',
    value: '',
  },

  {
    name: '无库存',
    value: '无库存',
  },
  {
    name: '缺少库存',
    value: '缺少库存',
  },
  {
    name: '商品未上架',
    value: '商品未上架',
  },
  {
    name: '无货源资质',
    value: '无货源资质',
  },
  {
    name: '未查询到商品',
    value: '未查询到商品',
  },
  {
    name: '销售范围内无库存',
    value: '销售范围内无库存',
  },
  {
    name: '销售范围内缺少库存',
    value: '销售范围内缺少库存',
  },
  {
    name: '销售范围内未查询到商品',
    value: '销售范围内未查询到商品',
  },
];

// 积分类型
export const integralTypes = [
  {
    name: '全部',
    value: -1,
  },
  {
    name: '签到',
    value: 9,
  },
  {
    name: '采购金额',
    value: 1,
  },
  {
    name: '报价单数',
    value: 2,
  },
  {
    name: '邀请用户注册',
    value: 3,
  },
  {
    name: '邀请用户完成首次交易',
    value: 4,
  },
  {
    name: '邀请用户升级为修理厂',
    value: 5,
  },
  {
    name: '邀请用户升级为经销商',
    value: 6,
  },
  {
    name: '邀请用户升级为卖家',
    value: 7,
  },
  {
    name: '邀请用户上传商品',
    value: 8,
  },
  {
    name: '新增OEM替换关系',
    value: 12,
  },
  {
    name: '纠错OEM替换关系',
    value: 13,
  },
];

// 签到类型
export const signTypes = [
  {
    name: '第一天',
    value: 1,
  },
  {
    name: '第二天',
    value: 2,
  },
  {
    name: '第三天',
    value: 3,
  },
  {
    name: '第四天',
    value: 4,
  },
  {
    name: '第五天',
    value: 5,
  },
  {
    name: '第六天',
    value: 6,
  },
  {
    name: '第七天',
    value: 7,
  },
];

// 短信模板发送状态
export const msgPushState = [
  {
    name: '全部',
    value: '',
  },
  {
    name: '发送成功',
    value: 1,
  },
  {
    name: '发送失败',
    value: 0,
  },
];

//  完整的用户类型
export const completeUserType = [
  {
    name: '全部',
    value: '',
  },
  {
    name: '品牌商',
    value: 1,
  },
  {
    name: '经销商卖家',
    value: 2,
  },
  {
    name: '经销商买家',
    value: 3,
  },
  {
    name: '修理厂',
    value: 4,
  },
  {
    name: '工厂',
    value: 6,
  },
];

// 公告系统类型
export const noticeSystemTypes = [
  {
    name: '全部',
    value: -1,
  },
  {
    name: '代理采购',
    value: 1,
  },
  {
    name: '同行采购',
    value: 2,
  },
  {
    name: '修理厂采购',
    value: 3,
  },
  {
    name: '车主采购',
    value: 8,
  },
  {
    name: '厂商联',
    value: 9,
  },
  {
    name: '英文版厂商联',
    value: 11,
  },
  {
    name: '工厂后台',
    value: 10,
  },
  {
    name: '品牌商后台',
    value: 4,
  },
  {
    name: '经销商后台',
    value: 5,
  },
  {
    name: '物流商后台',
    value: 6,
  },
  {
    name: '物流系统',
    value: 7,
  },
];

// 渠道类型
export const channelTypes = [
  {
    name: '全部',
    value: '',
  },
  {
    name: 'WEB',
    value: 1,
  },
  {
    name: 'WAP',
    value: 2,
  },
  {
    name: 'APP',
    value: 3,
  },
];

// 置顶枚举
export const isTopTypes = [
  {
    name: '全部',
    value: '',
  },
  {
    name: '是',
    value: 1,
  },
  {
    name: '否',
    value: 0,
  },
];

// 物流服务点类型
export const servicePointTypes = [
  {
    name: '全部',
    value: '',
  },
  {
    name: '通用',
    value: 0,
  },
  {
    name: '揽收地点',
    value: 1,
  },
  {
    name: '自提地点',
    value: 2,
  },
];

// 揽收类型
export const collectTypes = [
  {
    name: '全部',
    value: '',
  },
  {
    name: '上门取货',
    value: 1,
  },
  {
    name: '服务点揽收',
    value: 2,
  },
];

// 送货类型
export const deliveryTypes = [
  {
    name: '全部',
    value: '',
  },
  {
    name: '送货上门',
    value: 1,
  },
  {
    name: '服务点自提',
    value: 2,
  },
];

// 运单状态
export const waybillStatus = [
  {
    name: '全部',
    value: -1,
  },
  {
    name: '待揽收',
    value: 1,
  },
  {
    name: '派送中',
    value: 2,
  },
  {
    name: '待提货',
    value: 3,
  },
  {
    name: '异常件',
    value: 4,
  },
  {
    name: '已签收',
    value: 5,
  },
  {
    name: '已取消',
    value: 0,
  },
];

// 付款方
export const payerJson = [
  {
    name: '全部',
    value: '',
  },
  {
    name: '买方付',
    value: 2,
  },
  {
    name: '卖方付',
    value: 1,
  },
];

// 是否挂账
export const creditStatus = [
  {
    name: '全部',
    value: '',
  },
  {
    name: '是',
    value: 1,
  },
  {
    name: '否',
    value: 0,
  },
];

// 拼团活动状态 活动状态：1 未开始 2 活动中 3 已结束 4 已取消
export const activityStatusList = [
  {
    label: '未开始',
    value: 1,
  },
  {
    label: '活动中',
    value: 2,
  },
  {
    label: '已结束',
    value: 3,
  },
  {
    label: '已取消',
    value: 4,
  },
];

// 开票类型
export const openInvoiceTypeList = [
  {
    value: 1,
    label: '纸质发票',
  },
  {
    value: 2,
    label: '电子发票',
  },
];

// 短信渠道
export const noteDitchList = [
  {
    value: 1,
    label: '验证码渠道',
  },
  {
    value: 2,
    label: '营销渠道',
  },
];

// 技术资料详情类型
export const techInfoTypes = [
  { name: '全部', value: '' },
  { name: '图文详情', value: 1 },
  { name: 'PDF文件', value: 2 },
];
// 返利组状态 1 未开始 2 已开始 3 已结束 4 已停用
export const rebateStatusList = [
  { label: '未开始', value: 1 },
  { label: '进行中', value: 2 },
  { label: '已结束', value: 3 },
  { label: '已停用', value: 4 },
];

// jumpType
// 内容管理banner跳转类型 jumpType 1-不跳转 2-商品详情 3-店铺中心 4-web网页 5-商品搜索页 6-大牌尖货 7-原厂直供 8-国货爆品 9-拆车件 10-首页限时促销 11-首页拼团商品 12-智配自营专区 13-企业认证 14-智配自营新品速递 15-智配自营超值爆品 16-智配自营领券中心 17-爱车专区 18-加入厂商联 19-工厂名片(搜索选择) 20-招商加盟 21-厂商联配件列表页 22-厂商联精选货源列表页 23-甄选厂家 24-企业名片

// 内容管理公告通知跳转类型 jumpType 0-不跳转 2-商品详情 3-店铺中心 4-web网页 5-商品搜索页 6-大牌尖货 7-原厂直供 8-国货爆品 9-拆车件 10-首页限时促销 11-首页拼团商品 12-智配自营专区 14-智配自营新品速递 15-智配自营超值爆品 16-智配自营领券中心 17-爱车专区
export const jumpTypeList = [
  {
    label: '不跳转',
    value: 1,
  },
  {
    label: '商品详情',
    value: 2,
  },
  {
    label: '店铺中心',
    value: 3,
  },
  {
    label: 'web网页',
    value: 4,
  },
  {
    label: '商品搜索页',
    value: 5,
  },
  {
    label: '大牌尖货',
    value: 6,
  },
  {
    label: '原厂直供',
    value: 7,
  },
  {
    label: '国货爆品',
    value: 8,
  },
  {
    label: '拆车件',
    value: 9,
  },
  {
    label: '首页限时促销',
    value: 10,
  },
  {
    label: '首页拼团商品',
    value: 11,
  },
  {
    label: '智配自营专区',
    value: 12,
  },
  {
    label: '企业认证',
    value: 13,
  },
  {
    label: '智配自营新品速递',
    value: 14,
  },
  {
    label: '智配自营超值爆品',
    value: 15,
  },
  {
    label: '智配自营领券中心',
    value: 16,
  },
  {
    label: '爱车专区',
    value: 17,
  },
  {
    label: '加入厂商联',
    value: 18,
  },
  {
    label: '工厂名片',
    value: 19,
  },
  {
    label: '招商加盟',
    value: 20,
  },
  {
    label: '厂商联配件列表页',
    value: 21,
  },
  {
    label: '厂商联精选货源列表页',
    value: 22,
  },
  {
    label: '甄选厂家',
    value: 23,
  },
  {
    label: '企业名片(xcx)',
    value: 24,
  },
  {
    label: '厂商联店铺中心',
    value: 25,
  },
  {
    label: '厂商联商品详情',
    value: 26,
  },
  {
    label: '商品详情(xcx)',
    value: 27,
  },
  {
    label: '首页(xcx)',
    value: 28,
  },
  {
    label: '找经销商(xcx)',
    value: 29,
  },
  {
    label: '找修理厂(xcx)',
    value: 30,
  },
  {
    label: '信息广场(xcx)',
    value: 31,
  },
  {
    label: '视频广场(xcx)',
    value: 32,
  },
  {
    label: '英文版企业名片',
    value: 33,
  },
  {
    label: '英文版厂商联配件列表页',
    value: 34,
  },
  {
    label: '英文版厂商联精选货源列表页',
    value: 35,
  },
  {
    label: '英文版店铺中心',
    value: 36,
  },
  {
    label: '英文版商品详情',
    value: 37,
  },
];

// 优惠券种类
export const couponClassifies = [
  { name: '全部', value: '' },
  { name: '店铺券', value: 1 },
  { name: '商品券', value: 2 },
  { name: '品牌券', value: 3 },
  // { name: '补贴券', value: 4 },
];

// 优惠(折扣)类型
export const discountTypes = [
  { name: '全部', value: '' },
  { name: '满减券', value: 1 },
  { name: '叠加券', value: 2 },
  { name: '折扣券', value: 3 },
];

// 优惠券状态
export const couponStatus = [
  { name: '全部', value: '' },
  { name: '未开始', value: 1 },
  { name: '进行中', value: 2 },
  { name: '已领完', value: 3 },
  { name: '已过期', value: 4 },
  { name: '已结束', value: 5 },
];

// 数据统计-埋点-应用类型
export const platformTypeList = [
  { name: '全部', value: '' },
  { name: 'PC', value: 'pc' },
  { name: 'IOS', value: 'ios' },
  { name: 'Android', value: 'android' },
  { name: 'H5', value: 'h5' },
];

// 索赔状态
export const claimStatusList = [
  { name: '全部', value: '' },
  { name: '待处理', value: 0 },
  { name: '待退货', value: 4 },
  { name: '待卖家验货', value: 6 },
  { name: '索赔完成', value: 10 },
  { name: '拒绝索赔', value: 2 },
  { name: '验货失败', value: 8 },
  { name: '索赔取消', value: 9 },
];

export const afterSaleClaimList = [
  { name: '全部', value: '' },
  { name: '有售后', value: 1 },
  { name: '有索赔', value: 2 },
  { name: '有售后和索赔', value: 3 },
  { name: '无售后和索赔', value: 4 },
];

// 渠道（操作平台）
export const channelList = [
  {
    label: 'web',
    value: 1,
    disable: false,
  },
  {
    label: 'app',
    value: 2,
    disable: false,
  },
  {
    label: 'wap',
    value: 3,
    disable: false,
  },
  {
    label: 'xcx',
    value: 4,
    disable: false,
  },
];

export const appScreenRouteTypeList = [
  {
    label: '全部',
    value: '',
  },
  {
    label: '不跳转',
    value: 1,
  },
  {
    label: '商品详情',
    value: 2,
  },
  {
    label: '店铺中心',
    value: 3,
  },
  {
    label: 'web网页',
    value: 4,
  },
  {
    label: '商品搜索页',
    value: 13,
  },
  {
    label: '大牌尖货',
    value: 5,
  },
  {
    label: '原厂直供',
    value: 6,
  },
  {
    label: '国货爆品',
    value: 7,
  },
  {
    label: '拆车件',
    value: 8,
  },
  {
    label: '首页限时促销',
    value: 9,
  },
  {
    label: '首页拼团商品',
    value: 10,
  },
  {
    label: '智配自营专区',
    value: 11,
  },
  {
    label: '企业认证',
    value: 12,
  },
  {
    label: '智配自营新品速递',
    value: 14,
  },
  {
    label: '智配自营超值爆品',
    value: 15,
  },
  {
    label: '智配自营领券中心',
    value: 16,
  },
  {
    label: '工厂名片',
    value: 17,
  },
  {
    label: '企业名片（xcx）',
    value: 18,
  },
  {
    label: '厂商联店铺中心',
    value: 19,
  },
  {
    label: '厂商联商品详情',
    value: 20,
  },
  {
    label: '商品详情（xcx)',
    value: 21,
  },
  {
    label: '首页（xcx）',
    value: 22,
  },
  {
    label: '找经销商（xcx）',
    value: 23,
  },
  {
    label: '找修理厂（xcx）',
    value: 24,
  },
  {
    label: '信息广场（xcx）',
    value: 25,
  },
  {
    label: '视频广场（xcx）',
    value: 26,
  },
];

/**
 * 发布信息分类配置 - 使用者角度
 * userType: 3-经销商 4-修理厂 6-工厂
 */
const categoryList = [
  {
    pId: 0,
    id: 1,
    name: '产品供求',
    children: [
      {
        pId: 1,
        id: 11,
        name: '新品上市',
        userType: [6],
      },
      {
        pId: 1,
        id: 12,
        name: '门店到货',
        userType: [3],
      },
      {
        pId: 1,
        id: 13,
        name: '门店找货',
        userType: [3],
      },
      {
        pId: 1,
        id: 14,
        name: '维修求购',
        userType: [4],
      },
    ],
  },
  {
    pId: 0,
    id: 2,
    name: '技术互动',
    children: [
      {
        pId: 2,
        id: 21,
        name: '厂商指导',
        createName: '技术指导',
        userType: [6],
      },
      {
        pId: 2,
        id: 22,
        name: '门店分享',
        createName: '技术分享',
        userType: [3],
      },
      {
        pId: 2,
        id: 23,
        name: '维修求助',
        userType: [4],
      },
      {
        pId: 2,
        id: 24,
        name: '维修经验',
        createName: '经验分享',
        userType: [4],
      },
    ],
  },
  {
    pId: 0,
    id: 3,
    name: '营销动态',
    children: [
      {
        pId: 3,
        id: 31,
        name: '厂商活动',
        createName: '活动动态',
        userType: [6],
      },
      {
        pId: 3,
        id: 32,
        name: '门店活动',
        createName: '活动动态',
        userType: [3],
      },
      {
        pId: 3,
        id: 33,
        name: '维修活动',
        createName: '活动动态',
        userType: [4],
      },
    ],
  },
  {
    pId: 0,
    id: 4,
    name: '汽配杂谈',
    children: [
      {
        pId: 4,
        id: 41,
        name: '汽配杂谈',
        userType: [6],
      },
      {
        pId: 4,
        id: 42,
        name: '汽配杂谈',
        userType: [3],
      },
      {
        pId: 4,
        id: 43,
        name: '汽配杂谈',
        userType: [4],
      },
    ],
  },
];

// 获取一级分类
export function getFirstCategories() {
  return categoryList.map(({ id, name }) => ({ id, name }));
}

/**
 * 获取所有二级分类
 * @param {any} id 一级分类id
 * @returns {Array}
 */
export function getAllSecondCategories() {
  const secondCategories = [];
  categoryList
    .filter((item) => item.id !== 4)
    .map((item) => {
      item.children.map((second) => {
        secondCategories.push(second);
      });
    });
  secondCategories.push({
    pId: 4,
    id: '41,42,43',
    name: '汽配杂谈',
    userType: [3, 4, 6],
  });
  return secondCategories;
}

/**
 * 获取二级分类
 * @param {any} id 一级分类id
 * @returns {Array}
 */
export function getSecondCategories(parentId) {
  const temp = categoryList.find((item) => item.id === parentId) || {};
  return (temp.children || []).map(({ id, name }) => ({ id, name }));
}

/**
 * 获取创建者角度的分类
 * 1. 从创建角度获取不同用户类型的分类列表
 * @param {any} userType 3-经销商 4-修理厂 6-工厂
 * @returns {Array}
 */
export function getCreateCategories(userType) {
  const arr = [];
  categoryList.forEach((item) => {
    const temp = item.children
      .filter((item) => item.userType.includes(userType))
      .map((item) => ({
        id: item.id,
        name: item.createName || item.name,
      }));
    arr.push(...temp);

    if (item.userType && item.userType.includes(userType)) {
      arr.push({
        id: item.id,
        name: item.createName || item.name,
      });
    }
  });
  return arr;
}
